<template lang="pug">
div(:class="[$style.otherServicesSection, getReverseClass(block)]")
  Block(:block="block.innerBlocks[0]" :lazy="lazy")
  Block(:block="block.innerBlocks[1]" :lazy="lazy")
  Block(:block="block.innerBlocks[2]" :lazy="lazy")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { getBlockAttributes } from "~/utils/block"
import { OTHER_SERVICES_REVERSE } from "~/constants/blocks"

export default defineComponent({
  name: "OtherServicesSection",

  props: {
    block: {
      type: Object as () => Block,
      required: true
    },
    lazy: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    getReverseClass(block) {
      return getBlockAttributes(block).class.includes(OTHER_SERVICES_REVERSE) ? "reverse" : ""
    }
  }
})
</script>

<style lang="css" module>
.otherServicesSection {
  > *:nth-child(2) {
    @apply hidden;
  }
}

@screen md {
  .otherServicesSection {
    :global {
      .av-heading {
        @apply mb-ds-lg text-center;
      }

      .av-link-table {
        @apply justify-center;
      }
    }
  }
}

@screen lg {
  .otherServicesSection {
    @apply grid;
    grid-template-rows: auto auto;
    grid-template-columns: 5fr 1fr 6fr;
    grid-template-areas:
      "image gap heading"
      "image gap table";

    &:global(.reverse) {
      grid-template-columns: 6fr 1fr 5fr;
      grid-template-areas:
        "heading gap image"
        "table gap image";
    }

    > *:nth-child(1) {
      grid-area: heading;
    }

    > *:nth-child(2) {
      grid-area: image;
      @apply block;
    }

    > *:nth-child(3) {
      grid-area: table;
    }

    :global {
      .av-heading {
        @apply mb-ds-md text-left self-center;
      }

      .av-link-table {
        @apply justify-start;
      }
    }
  }
}
</style>
